import React, { createContext, useContext, useMemo, useState } from "react";
import { Outlet } from "react-router-dom";

const Context = createContext();

const StoreRecommendationProvider = () => {
	const [service, setService] = useState([]);
	const [mapDataCache, setMapDataCache] = useState({
		masterPolygonsByStateKey: {},
		onlinePolygonsByStateKey: {},
		skaterPolygonsByFilterKey: {},
		storePointsByStateKey: {},
		competitorPointsByStateKey: {},
	});

	const contextValue = useMemo(
		() => ({
			service,
			setService,
			mapDataCache,
			setMapDataCache,
		}),
		[mapDataCache, service],
	);

	return (
		<Context.Provider value={contextValue}>
			<Outlet />
		</Context.Provider>
	);
};

export const StoreRecommendationState = () => useContext(Context);

export default StoreRecommendationProvider;
